module.exports = "/_next/static/images/e7f8d84fdce0f9f8c5e97ebe87bd9f61-mgm-10-million-mobile.jpg.webp";